export const getTwoTupleValueByKey = (arrayOfTuples, key) => {
  const result = arrayOfTuples.find(
    tuple => tuple.length > 1 && tuple[0] === key
  )
  if (result) {
    return result[1]
  }
}
